import TransparentButton from "@/components/business-model/TransparentButton";
import PagesHeader from "@/components/common/PagesHeader";
import Layout from "@/components/layout/Layout";
import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Link from "next/link";

const CONTACT_US_TEXT = "Contact Us";

const EngagementModel = () => (
  <Layout
    description={
      "ultoNeous offers flexible and result-oriented Business Models for software development. Hire best software developers from us at the affordable pricing."
    }
    title={"Pricing & Business Models at ultroNeous Technologies"}
  >
    <PagesHeader
      heading="Every Business is different"
      subheading="We have a business model for all!"
      text="Business Models"
    />
    <div className="bg-primary-black text-center text-white items-center flex flex-col pt-16 px-4 md:pt-8 md:px-10 pb-0 lg:pb-16">
      <p className="font-normal text-justify md:text-center text-sm md:text-lg max-w-screen-xl pb-4">
        Being industry experts, we are aware that every customer and business
        has different processes and plans to cater to their success. ultroNeous
        understands the same and offers various Business Business Models to suit
        your requirement. Whether you have a good sizable enterprise project, an
        idea with a defined scope, or a need to fill the place with missing
        experts in your team, we have a solution for you.
      </p>
      <p className="font-normal text-justify md:text-center text-sm md:text-lg max-w-screen-md pb-4">
        It is very important to choose the right model to ensure the best
        progress in your project. Talk to our expert now to identify the one
        suitable for you.
      </p>
    </div>
    <div className="pt-1 lg:pt-16 px-1 lg:px-16 pb-16 md:pb-1 lg:pb-32 bg-[#f9f9f9]">
      <div className="flex items-center justify-around">
        <div className="px-3">
          <div className="justify-around scroll-smooth">
            <div className="pb-12 md:pb-5 pt-12 text-center w-full scroll-smooth">
              <div>
                <ul className="p-0 m-0 scroll-smooth">
                  <li className="sticky top-[calc(44vh_-_203px)] md:top-[calc(50vh_-_203px)] bg-white scroll-smooth transition-all duration-1000 ease-linear mt-8 rounded-[20px] md:rounded-7.5 h-[520px] justify-center items-center flex min-w-80">
                    <div className="block md:flex items-center justify-center">
                      <div className="m-0 md:w-1/2">
                        <h2 className="text-xl md:text-3xl lg:text-5xl font-medium pl-4 md:pl-8 lg:pl-16 flex m-0 pt-0 md:t-8 md:pb-8 justify-start text-primary-yellow leading-[75px]">
                          Staff Augmentation
                        </h2>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Are you tired of finding the correct person to fill
                          your existing project team or upcoming projects? Let
                          us take care of your&nbsp;
                          <Link
                            href={LINK_OF_ALL_PAGES.services.staffAugmentation}
                          >
                            <a>
                              <span className="text-deep-sky-blue">
                                IT Staff Augmentation Service
                              </span>
                            </a>
                          </Link>
                          &nbsp;which includes recruitment, training and
                          supplying the required resources (from designer to PM)
                          to work with your team.
                        </p>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Now, no need to go through a lengthy paperwork’s and
                          tons of documentation Get a team member with an easy
                          application process and the best talents, be it an
                          individual or a group of developers, they will add
                          value to your workforce.
                        </p>
                        <span className="font-normal mt-8 text-left pl-4 md:pl-8 lg:pl-16 flex text-primary-black">
                          <TransparentButton
                            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
                            val={CONTACT_US_TEXT}
                          />
                        </span>
                      </div>
                      <div className="m-0 md:w-1/2">
                        <div>
                          <div className="flex flex-wrap justify-center">
                            <div className="xl:w-1/3 w-1/2">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Profile  Requirement "
                                  height={105}
                                  src="/assets/business-model/shareprojectrequirement3.webp"
                                  title="Profile  Requirement  "
                                  width={141}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Review Profile"
                                  height={102}
                                  src="/assets/business-model/reviewprofile.webp"
                                  title="Review Profile"
                                  width={113}
                                />
                              </div>
                            </div>
                            <div className="pr-8 xl:w-1/3 w-1/2">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Meet the Candidate"
                                  height={101}
                                  src="/assets/business-model/meetthecandidate.webp"
                                  title="Meet the Candidate"
                                  width={114}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Start the Contract"
                                  height={101}
                                  src="/assets/business-model/startthecontract3.webp"
                                  title="Start the Contract"
                                  width={119}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="sticky top-[calc(44vh_-_203px)] md:top-[calc(50vh_-_203px)] rounded-[20px] md:rounded-7.5 bg-white scroll-smooth transition-all duration-1000 ease-linear h-[520px] justify-center items-center flex min-w-80">
                    <div className="block md:flex items-center justify-center">
                      <div className="m-0 md:w-1/2">
                        <h2 className="text-xl md:text-3xl lg:text-5xl font-medium pl-4 md:pl-8 lg:pl-16 flex m-0 pt-0 md:pt-8 md:pb-8 justify-start text-primary-yellow leading-[75px]">
                          Dedicated Team Hiring
                        </h2>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Do you want to build your on-demand product team for
                          agile development? Let us build your fully functional
                          dedicated team by supplying FULL-TIME resources
                          consisting of designers, developers, QC, project
                          managers & more.
                        </p>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Our dedicated team hiring process not only provides
                          developers with an experience of 5+ years who work on
                          transparent approach that will help you get a detailed
                          flow of the development process but also
                          provides&nbsp;
                          <Link
                            href={
                              LINK_OF_ALL_PAGES.services.itConsultationAssistance
                            }
                          >
                            <a>
                              <span className="text-deep-sky-blue">
                                IT consulting services
                              </span>
                            </a>
                          </Link>
                          &nbsp;for better results.
                        </p>
                        <span className="font-normal mt-8 text-left pl-4 md:pl-8 lg:pl-16 flex text-primary-black">
                          <TransparentButton
                            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
                            val={CONTACT_US_TEXT}
                          />
                        </span>
                      </div>
                      <div className="m-0 md:w-1/2">
                        <div>
                          <div className="flex flex-wrap justify-center">
                            <div className="w-1/2 xl:w-1/3">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Product  Team"
                                  height={103}
                                  src="/assets/business-model/defineproductteam.webp"
                                  title="Product  Team"
                                  width={98}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Agree on Commercials"
                                  height={103}
                                  src="/assets/business-model/agreeoncommercials.webp"
                                  title="Agree on Commercials"
                                  width={113}
                                />
                              </div>
                            </div>
                            <div className="xl:w-1/3 w-1/2">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125 ml-4">
                                <Image
                                  alt="Start the Contract"
                                  height={101}
                                  src="/assets/business-model/startthecontract.webp"
                                  title="Start the Contract"
                                  width={113}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Project Sprints"
                                  height={104}
                                  src="/assets/business-model/difineprojectsprints.webp"
                                  title="Project Sprints"
                                  width={119}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="sticky top-[calc(44vh_-_203px)] md:top-[calc(50vh_-_203px)] rounded-[20px] md:rounded-7.5 bg-white scroll-smooth transition-all duration-1000 ease-linear h-[520px] justify-center items-center flex min-w-80">
                    <div className="block md:flex items-center justify-center">
                      <div className="m-0 md:w-1/2">
                        <h2 className="text-xl md:text-3xl lg:text-5xl font-medium pl-4 md:pl-8 lg:pl-16 flex m-0 pt-0 md:pt-8 md:pb-8 justify-start text-primary-yellow leading-[75px]">
                          Project Basis
                        </h2>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Do you want to work on a mid-size project with a clear
                          set of requirements and/ or scope of work? With this
                          business model, the team will document your
                          requirements with defined technical solutions, time
                          frames, and budget.
                        </p>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Take a seat back and relax now as your project is our
                          responsibility. Get the best&nbsp;
                          <Link href={LINK_OF_ALL_PAGES.mainPages.home}>
                            <a>
                              <span className="text-deep-sky-blue">
                                software development services
                              </span>
                            </a>
                          </Link>
                          &nbsp;and solutions at the most competitive pricing.
                        </p>
                        <span className="font-normal mt-8 text-left pl-4 md:pl-8 lg:pl-16 flex text-primary-black">
                          <TransparentButton
                            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
                            val={CONTACT_US_TEXT}
                          />
                        </span>
                      </div>
                      <div className="m-0 md:w-1/2">
                        <div>
                          <div className="flex flex-wrap justify-center">
                            <div className="xl:w-1/3 w-1/2">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Project Requirement "
                                  height={106}
                                  src="/assets/business-model/shareprojectrequirement.webp"
                                  title="Project Requirement "
                                  width={146}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Scope of Work"
                                  height={105}
                                  src="/assets/business-model/difinescopeofwork.webp"
                                  title="Scope of Work"
                                  width={113}
                                />
                              </div>
                            </div>
                            <div className="pr-8 w-1/2 xl:w-1/3">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125 ml-4">
                                <Image
                                  alt="Project Price & Plan"
                                  height={104}
                                  loading="lazy"
                                  src="/assets/business-model/difineprojectpriceplan.webp"
                                  title="Project Price & Plan"
                                  width={138}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Start the Contract"
                                  height={101}
                                  loading="lazy"
                                  src="/assets/business-model/startthecontract3.webp"
                                  title="Start the Contract"
                                  width={119}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="sticky top-[calc(44vh_-_203px)] md:top-[calc(50vh_-_203px)] rounded-[20px] md:rounded-7.5 bg-white scroll-smooth transition-all duration-1000 ease-linear h-[520px] justify-center items-center flex min-w-80">
                    <div className="block md:flex items-center justify-center">
                      <div className="m-0 md:w-1/2">
                        <h2 className="text-xl md:text-3xl lg:text-5xl font-medium pl-4 md:pl-8 lg:pl-16 flex m-0 pt-0 md:pt-8 md:pb-8 justify-start text-primary-yellow leading-[75px]">
                          Technology Partner
                        </h2>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Do you want to be our B2B partner? We know that it is
                          not always possible to have the required technology
                          experts, and that is where our software development
                          services come into play. While we focus on filling
                          your shortage of resources, rest assured that your
                          ideas/ clients are secured with us.
                        </p>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Our experts serve in various technologies such as
                          MEAN, MERN, Flutter, iOS and to name more. Partner
                          with us to get the best technology stack and guidance
                          for your project.
                        </p>
                        <span className="font-normal mt-8 text-left pl-4 md:pl-8 lg:pl-16 flex text-primary-black">
                          <TransparentButton
                            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
                            val={CONTACT_US_TEXT}
                          />
                        </span>
                      </div>
                      <div className="m-0 md:w-1/2">
                        <div>
                          <div className="flex flex-wrap justify-center">
                            <div className="w-1/2 xl:w-1/3">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Discuss Requirement "
                                  height={105}
                                  loading="lazy"
                                  src="/assets/business-model/discussongoing.webp"
                                  title="Discuss Requirement "
                                  width={147}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Resource Profile"
                                  height={102}
                                  loading="lazy"
                                  src="/assets/business-model/shareresourceprofiles.webp"
                                  title="Resource Profile"
                                  width={114}
                                />
                              </div>
                            </div>
                            <div className="xl:w-1/3 w-1/2">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Meet the Candidate"
                                  height={105}
                                  src="/assets/business-model/meetthecandidate3.webp"
                                  title="Meet the Candidate"
                                  width={147}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Start the Contract"
                                  height={101}
                                  src="/assets/business-model/startthecontract3.webp"
                                  title="Start the Contract"
                                  width={119}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="sticky top-[calc(44vh_-_203px)] md:top-[calc(50vh_-_203px)] rounded-[20px] md:rounded-7.5 bg-white scroll-smooth transition-all duration-1000 ease-linear h-[520px] justify-center items-center flex min-w-80">
                    <div className="block md:flex items-center justify-center">
                      <div className="m-0 md:w-1/2">
                        <h2 className="text-xl md:text-3xl lg:text-5xl font-medium pl-4 md:pl-8 lg:pl-16 flex m-0 pt-0 md:pt-8 md:pb-8 justify-start text-primary-yellow leading-[75px]">
                          Maintenance & Support
                        </h2>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Are you stuck in finding a reliable&nbsp;
                          <Link
                            href={
                              LINK_OF_ALL_PAGES.services.customSoftwareDevelopment
                            }
                          >
                            <a>
                              <span className="text-deep-sky-blue">
                                custom software development company
                              </span>
                            </a>
                          </Link>
                          &nbsp;to take care of your existing product, or who
                          can clear the mess your previous agency created? We
                          can take care of your product on a daily basis or
                          upgrade your product with a set of new features
                          development.
                        </p>
                        <p className="pl-4 md:pl-8 lg:pl-16 pr-4 md:pr-8 lg:pr-16 text-base font-normal leading-5 text-justify text-primary-black mb-4">
                          Our support team works hard to make sure that there
                          are no glitches faced on live website or mobile app.
                          We make sure that our clients gets the best and smooth
                          running product.
                        </p>
                        <span className="font-normal mt-8 text-left pl-4 md:pl-8 lg:pl-16 flex text-primary-black">
                          <TransparentButton
                            link={LINK_OF_ALL_PAGES.mainPages.contactUs}
                            val={CONTACT_US_TEXT}
                          />
                        </span>
                      </div>
                      <div className="m-0 md:w-1/2">
                        <div className="justify-center">
                          <div className="flex flex-wrap justify-center">
                            <div className="w-1/2 xl:w-1/3">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Understand Product"
                                  height={102}
                                  src="/assets/business-model/understandproject.webp"
                                  title="Understand Product"
                                  width={143}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="pt-0 pb-0 hidden md:inline-block transition-all duration-1000 ease-linear md:pb-16 md:pt-4 hover:scale-125">
                                <Image
                                  alt="Setup & Review Codebase"
                                  height={102}
                                  src="/assets/business-model/setupreviewcode.webp"
                                  title="Setup & Review Codebase"
                                  width={124}
                                />
                              </div>
                            </div>
                            <div className="xl:w-1/3 w-1/2">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Define Support Type"
                                  height={104}
                                  loading="lazy"
                                  src="/assets/business-model/difinesupport.webp"
                                  title="Define Support Type"
                                  width={144}
                                />
                              </div>
                            </div>
                            <div className="w-1/2 xl:w-5/12">
                              <div className="hidden md:inline-block transition-all duration-1000 ease-linear hover:scale-125">
                                <Image
                                  alt="Start the Contract"
                                  height={101}
                                  src="/assets/business-model/startthecontract3.webp"
                                  title="Start the Contract"
                                  width={119}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);
export default EngagementModel;
